import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

/**
 * Iter 81 — celebratory toast when a referred user signs up.
 *
 * Listens to the global `trigo:ws-message` event stream for
 * `referral_signup` payloads emitted by the backend's `/auth/register`
 * handler. On receipt we:
 *   1. Fire a "+150 TFT 🎉" toast on top of whatever page is open.
 *   2. Refresh the auth context so the new TFT balance surfaces in
 *      every balance pill (header, wallet, driver dashboard) without
 *      requiring a manual reload.
 */
export default function ReferralToastListener() {
  const { checkAuth, user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;
    const onMsg = (ev) => {
      const d = ev?.detail;
      if (d?.type === "referral_milestone") {
        toast.success(`Palier ${d.target} filleuls débloqué : +${Number(d.amount).toLocaleString("fr-FR")} TFT 🏆`, {
          description: "Votre bonus ambassadeur vient d'être crédité.",
          duration: 9000,
        });
        api.get("/auth/me").then(() => checkAuth?.()).catch(() => {});
        return;
      }
      if (!d || d.type !== "referral_signup") return;
      const amount = Number(d.amount || 150);
      const who = d.referred_name || "un nouveau filleul";
      toast.success(`+${amount} TFT 🎉`, {
        description: `${who} vient de s'inscrire avec votre code${d.referral_code ? " " + d.referral_code : ""}.`,
        duration: 7000,
      });
      // Pull /auth/me so every TFT pill in the UI updates on its own.
      api.get("/auth/me").then(() => checkAuth?.()).catch(() => {});
    };
    window.addEventListener("trigo:ws-message", onMsg);
    return () => window.removeEventListener("trigo:ws-message", onMsg);
  }, [user?.id, checkAuth]);

  return null;
}
